import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-50 text-[15px] selection:bg-cyan-400/30 selection:text-cyan-50">
      <div className="mx-auto max-w-md min-h-screen flex flex-col">
        <main className="flex flex-1 items-center justify-center px-4 py-6">
          <section className="w-full rounded-3xl bg-slate-900/40 ring-1 ring-cyan-300/25 p-5">
            <header className="flex items-center justify-center gap-3 text-center">
              <img src="/static/img/site-logo.png" alt="" className="h-16 w-16 object-contain" />
              <div className="min-w-0">
                <div
                  className="text-2xl font-semibold tracking-tight"
                  style={{
                    textShadow: "0 0 14px rgba(6,182,212,0.48), 0 0 22px rgba(217,70,239,0.34)",
                    filter: "drop-shadow(0 0 8px rgba(255,255,255,0.28))"
                  }}
                >
                  <span className="text-cyan-200">Human</span>{" "}
                  <span className="text-fuchsia-200">Jukebox</span>
                </div>
              </div>
            </header>

            <div className="mt-8 text-center">
              <p
                className="text-6xl sm:text-7xl font-bold tracking-tight tabular-nums"
                style={{
                  textShadow: "0 0 20px rgba(6,182,212,0.35), 0 0 28px rgba(217,70,239,0.25)"
                }}
              >
                <span className="text-cyan-200">4</span>
                <span className="text-slate-100">0</span>
                <span className="text-fuchsia-200">4</span>
              </p>
              <h1 className="mt-4 text-lg font-semibold text-slate-100">Page not found</h1>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">
                This URL doesn’t match anything in the app. Check the address or head back to sign in.
              </p>
            </div>

            <div className="mt-8 space-y-3">
              <Link
                to="/login"
                className="flex w-full items-center justify-center gap-2 rounded-2xl bg-cyan-500/20 hover:bg-cyan-500/25 ring-1 ring-cyan-300/30 px-4 py-3 text-sm font-semibold text-cyan-50"
              >
                <i className="fa-solid fa-right-to-bracket text-xs opacity-90" aria-hidden />
                Sign in
              </Link>
              <a
                href="/dashboard/"
                className="flex w-full items-center justify-center gap-2 rounded-2xl bg-slate-950/40 hover:bg-slate-950/55 ring-1 ring-white/10 px-4 py-3 text-sm font-semibold text-slate-200"
              >
                <i className="fa-solid fa-gauge-high text-xs opacity-90" aria-hidden />
                Open dashboard
              </a>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}
